// Step 5: the kept answers. Listen, remove (with a confirm), continue, or record another.
import { logger } from '../lib/log.js';
import { announce } from '../lib/forms.js';
import { $, el, show, fmtLength, plural } from './dom.js';
import { togglePlay } from './player.js';

const log = logger('record');

export function createReviewScreen(app) {
  const { root, state, data } = app;
  const sec = $('[data-step="review"]', root);
  const list = $('[data-review-list]', sec);
  const empty = $('[data-review-empty]', sec);
  const fullNote = $('[data-review-full]', sec);
  const intro = $('[data-review-intro]', sec);
  const cont = $('[data-review-continue]', sec);
  const more = $('[data-review-more]', sec);

  function render() {
    const n = state.clips.length;
    show(empty, n === 0);
    show(list, n > 0);
    show(intro, n > 0);
    show(cont, n > 0);
    show(fullNote, app.isFull());
    show(more, !app.isFull());
    more.textContent = n ? 'Record another answer' : 'Choose a topic';
    list.replaceChildren(...state.clips.map((c, i) => {
      const p = data.promptById(c.promptId);
      const meta = [data.topicTitleFor(c.promptId), fmtLength(c.durationSec), c.source === 'uploaded' ? 'Uploaded file' : null].filter(Boolean).join(' · ');
      return el('li', { class: 'rec-clip', 'data-clip': c.id }, [
        el('p', { class: 'rec-clip__n' }, `Answer ${i + 1}`),
        el('h3', { class: 'rec-clip__q', id: `rec-clip-${c.id}`, tabindex: '-1' }, p ? p.text : 'A question we no longer ask'),
        el('p', { class: 'rec-clip__meta' }, meta),
        el('div', { class: 'rec-actions' }, [
          el('button', { type: 'button', class: 'btn btn-ghost rec-play', 'data-play-clip': c.id, 'aria-describedby': `rec-clip-${c.id}` }, [
            el('span', { class: 'rec-play__icon', 'aria-hidden': 'true' }), el('span', { 'data-play-label': '' }, 'Listen'),
          ]),
          el('button', { type: 'button', class: 'btn-link rec-clip__remove', 'data-remove-clip': c.id, 'aria-describedby': `rec-clip-${c.id}` }, 'Remove'),
        ]),
        el('div', { class: 'oh-notice oh-notice--warn rec-confirm', 'data-remove-confirm': c.id, hidden: true }, [
          el('p', { tabindex: '-1', 'data-remove-confirm-text': '' }, [el('strong', {}, 'Remove this answer?'), ' It will be deleted from this device.']),
          el('div', { class: 'rec-actions' }, [
            el('button', { type: 'button', class: 'btn btn-danger', 'data-remove-yes': c.id }, 'Yes, remove it'),
            el('button', { type: 'button', class: 'btn btn-ghost', 'data-remove-no': c.id }, 'Keep it'),
          ]),
        ]),
      ]);
    }));
  }

  const clipById = (id) => state.clips.find((c) => c.id === id);
  list.addEventListener('click', async (e) => {
    const t = e.target.closest('button');
    if (!t) return;
    const play = t.getAttribute('data-play-clip');
    const rm = t.getAttribute('data-remove-clip');
    const yes = t.getAttribute('data-remove-yes');
    const no = t.getAttribute('data-remove-no');
    if (play) { const c = clipById(play); if (c) togglePlay(t, { url: c.url, durationSec: c.durationSec, where: 'review', promptId: c.promptId }); }
    if (rm) {
      const box = $(`[data-remove-confirm="${rm}"]`, list);
      show(box, true);
      $('[data-remove-confirm-text]', box).focus();
      announce('Remove this answer? It will be deleted from this device.');
    }
    if (no) {
      show($(`[data-remove-confirm="${no}"]`, list), false);
      const b = $(`[data-remove-clip="${no}"]`, list);
      if (b) b.focus();
    }
    if (yes) {
      const c = clipById(yes);
      if (!c) return;
      const i = state.clips.indexOf(c);
      await app.removeClip(c, { reason: 'review' });
      render();
      const n = state.clips.length;
      const nextH = n ? $(`#rec-clip-${state.clips[Math.min(i, n - 1)].id}`, list) : $('[data-review-empty]', sec);
      if (nextH) { if (!nextH.hasAttribute('tabindex')) nextH.setAttribute('tabindex', '-1'); nextH.focus(); }
      announce(n ? `Answer removed. You have ${plural(n, 'answer', 'answers')} left.` : 'Answer removed. You have no answers left.');
    }
  });

  app.on('to-review', () => {
    if (state.step === 'prompt') { app.requestLeavePrompt({ type: 'review' }); return; }
    app.go('review');
  });
  app.on('to-about', () => {
    if (!state.clips.length) { app.go('review'); return; }
    log.info('review_continue', { kept: state.clips.length });
    app.go('about');
  });

  return { onShow: render };
}
